import React from 'react';

export default function Title({className}) {

	return <div className={`page-title__wrapper ${className ? className : ''}`}>
		<h1 className={`page-title__text`}>Conveyancing quote</h1>
	</div>
}
